import type { ChapterConfig } from './types'
import { commonTexts } from './common'

/**
 * Oceread 品牌 - Chapter 页面配置
 */
export const chapterConfig: ChapterConfig = {
  texts: {
    ...commonTexts,
    // Oceread 特定文案覆盖(如有需要)
  },
  colors: {
    coinsGradient: 'linear-gradient(180deg, #6B92FD, #ffffff)',
    coinsPopupText1: '#FFFFFF',
    coinsPopupText2: '#FF873F',
    coinsPopupText3: '#65686F',
    coinsPopupText4: '#FFFFFF',
    // 充值弹窗颜色配置
    vipBg: '#EDF2FF',
    subscribeActiveBg: '#F3F5FA',
    purpleTextGradient: 'linear-gradient(180deg, #A3BBFF 0%, #C6D1ED 70%, #F3F5FA 100%)',
    pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
    // 会员订阅背景图
    memberSubscribeBg: '/images/oceread/chapter/member_subscribe_bg.webp',
  },
}
